import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
    APP_TOOLTIP_BODY_COLOR,
    APP_TOOLTIP_BODY_WEIGHT,
    APP_TOOLTIP_FONT_FAMILY,
    APP_TOOLTIP_FONT_SIZE,
    APP_TOOLTIP_LINE_HEIGHT,
    APP_TOOLTIP_TITLE_WEIGHT,
    appTooltipTypography,
} from '../../theme/appTooltipTypography';

export const PopoverContent = styled.div`
  max-width: 280px;
  font-family: ${APP_TOOLTIP_FONT_FAMILY};
  font-size: ${APP_TOOLTIP_FONT_SIZE};
  line-height: ${APP_TOOLTIP_LINE_HEIGHT};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const PopoverTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-family: ${APP_TOOLTIP_FONT_FAMILY};
  font-size: ${APP_TOOLTIP_FONT_SIZE};
  font-weight: ${APP_TOOLTIP_TITLE_WEIGHT};
  color: #ffffff;
  line-height: ${APP_TOOLTIP_LINE_HEIGHT};
  margin-bottom: 0.35rem;
`;

export const PopoverTitleIcon = styled.span`
  font-size: ${APP_TOOLTIP_FONT_SIZE};
  line-height: 1;
`;

export const PopoverBody = styled.p`
  margin: 0;
  font-family: ${APP_TOOLTIP_FONT_FAMILY};
  font-size: ${APP_TOOLTIP_FONT_SIZE};
  font-weight: ${APP_TOOLTIP_BODY_WEIGHT};
  line-height: ${APP_TOOLTIP_LINE_HEIGHT};
  color: ${APP_TOOLTIP_BODY_COLOR};
`;

export const PopoverDivider = styled.hr`
  margin: 0.75rem 0 0.65rem;
  border: none;
  border-top: 1px solid rgba(148, 163, 184, 0.22);
`;

export const PopoverLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: ${APP_TOOLTIP_FONT_FAMILY};
  font-size: ${APP_TOOLTIP_FONT_SIZE};
  font-weight: ${APP_TOOLTIP_BODY_WEIGHT};
  line-height: ${APP_TOOLTIP_LINE_HEIGHT};
  color: #f45b68 !important;
  text-decoration: none !important;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
    color: #ff8a94 !important;
  }
`;

export const EstimatedBadgeRoot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 9999px;
  border: 1px solid #fde68a;
  background-color: #fef3c7;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
  white-space: nowrap;
  vertical-align: middle;
  flex-shrink: 0;
  font-family: ${APP_TOOLTIP_FONT_FAMILY};
  line-height: 1.2;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};

  [data-bs-theme='dark'] & {
    background-color: rgba(250, 204, 21, 0.16);
    border-color: rgba(250, 204, 21, 0.38);
    box-shadow: none;
  }
`;

export const EstimatedBadgeIcon = styled.span`
  color: #eab308;
  font-size: 10px;
  line-height: 1;
  flex-shrink: 0;

  [data-bs-theme='dark'] & {
    color: #facc15;
  }
`;

export const EstimatedBadgeText = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #78716c;

  [data-bs-theme='dark'] & {
    color: #e2e8f0;
  }
`;
